import useFetchApi from "@/api/hooks/useFetchApi";
import React from "react";
import { Link, useParams } from "react-router-dom";

interface GalleryCardProps {
    data?: any;
    isLoading?: boolean;
    category?: string;
}

const GalleryCard: React.FC<GalleryCardProps> = () => {
    const { category } = useParams<{ category: string }>();
    const {
        data: galleryData,
        isLoading,
        error,
    } = useFetchApi({
        url: `/v1/main-module/678764e5d187a284903c5e8f/collection/find?list_related=false&list_referenced=false&module_populate=6787657cd187a284903c612c&limit=0&skip=0&search=title:$eq:${category}`,
        service: "CMS_PROC",
    });

    // if (isLoading) return <div>Yükleniyor...</div>;
    if (error) return <div>Hata! Veriler Yüklenemedi</div>;

    return (
        <section className="ls page_portfolio section_padding_top_100 section_padding_bottom_75">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div
                            className="isotope_container isotope row masonry-layout columns_margin_top_0 columns_margin_bottom_30"
                            data-filters=".isotope_filters"
                        >
                            {category === "Video" ? (
                                <section className="ls section_padding_70">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="embed-responsive embed-responsive-3by2">
                                                    <iframe
                                                        className="embed-responsive-item"
                                                        src="https://www.youtube.com/embed/xKxrkht7CpY"
                                                        title="YouTube Video"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            ) :

                                // Resimler
                                (
                                    galleryData?.results?.map((result: any) =>
                                        result?.populated?.["Galeri İçerikler"]?.records?.map((item: any) => (
                                            <div
                                                className="isotope-item col-lg-4 col-md-6 col-sm-12 photography"
                                                key={item.id}
                                            >
                                                <div className="vertical-item gallery-item content-absolute text-center cs">
                                                    <div className="item-media myGalleryImg">
                                                        <img
                                                            src={item.resim || "placeholder-image.png"}
                                                            alt={item.title}
                                                            style={{ objectFit: "contain" }}
                                                        />
                                                        <div className="media-links">
                                                            <div className="links-wrap">
                                                                <Link
                                                                    className="p-view prettyPhoto"
                                                                    data-gal="prettyPhoto[gal]"
                                                                    to={item.resim || "#"}
                                                                ></Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="item-content">
                                                        <h4 className="item-meta greylinks">{item.title}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GalleryCard;
